import { render, staticRenderFns } from "./BaseError.vue?vue&type=template&id=2528f1fc"
import script from "./BaseError.vue?vue&type=script&lang=js"
export * from "./BaseError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports